import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const baseOptions = {
  autoClose: 5000,
  hideProgressBar: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  closeOnClick: true,
  draggable: true,
  position: "bottom-center",
};

export const Notify = (props) => {
  let text = props.text ? props.text : "";
  let type = props.type ? props.type : "";

  if (type === "success") {
    toast.success(text, {
      ...baseOptions,
      className: "toast-success-container toast-success-container-after",
    });
  } else if (type === "warning") {
    toast.warn(text, {
      ...baseOptions,
      className: "toast-warn-container toast-warn-container-after",
    });
  } else if (type === "error") {
    toast.error(text, {
      ...baseOptions,
      className: "toast-error-container toast-error-container-after",
    });
  } else if (type === "info") {
    toast.info(text, {
      ...baseOptions,
      className: "toast-info-container toast-info-container-after",
    });
  }
};

const customToast = {
  success(msg, options = {}) {
    return toast.success(msg, {
      ...baseOptions,
      ...options,
      className: "toast-success-container toast-success-container-after",
    });
  },
  error(msg, options = {}) {
    return toast.error(msg, {
      ...baseOptions,
      ...options,
      className: "toast-error-container toast-error-container-after",
    });
  },
  info(msg, options = {}) {
    return toast.info(msg, {
      ...baseOptions,
      ...options,
      className: "toast-info-container toast-info-container-after",
    });
  },
  warning(msg, options = {}) {
    return toast.warn(msg, {
      ...baseOptions,
      ...options,
      className: "toast-warn-container toast-warn-container-after",
    });
  },
  dismiss(toastId) {
    return toast.dismiss(toastId);
  },
  errorwithlink(msg, linkText, linkTo, options = {}) {
    const toastOptions = {
      ...baseOptions,
      ...options,
      className: "toast-error-container toast-error-container-after",
    };

    toast.error(
      <div className="toast-message-content">
        {msg}{" "}
        <Link className="toast-inline-link" to={linkTo}>
          {linkText}
        </Link>
      </div>,
      toastOptions
    );
  },
  successwithlink(msg, onClicksText, onClickfunction, options = {}) {
    const toastOptions = {
      ...baseOptions,
      ...options,
      className: "toast-success-container toast-success-container-after",
      autoClose: false,
      toastId: "linkToast",
    };

    toast.success(
      <div className="toast-message-content">
        {msg}{" "}
        <a className="toast-inline-link" onClick={onClickfunction}>
          {onClicksText}
        </a>
      </div>,
      toastOptions
    );
  },
  withprogessbar(msg, options = {}) {
    const toastOptions = {
      ...baseOptions,
      ...options,
      className: "toast-success-container toast-success-container-after",
      autoClose: false,
      hideProgressBar: true,
      icon: false,
      toastId: "progressBarToast",
    };

    toast.success(
      <div className="custom-toasts-notification-progress">
        <span>{msg}</span>
        <div className="progress my-2">
          <div
            className="progress-bar progress-bar-striped progress-bar-animated progess-bar-custom-toast"
            role="progressbar"
            aria-valuenow="100"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{
              width: "100%",
              backgroundImage:
                "linear-gradient(45deg, #FBD2C3 25%, transparent 25%, transparent 50%, #FBD2C3 50%, #FBD2C3 75%, transparent 75%, transparent)",
              backgroundColor: "#8c1c4d",
            }}
          ></div>
        </div>
      </div>,
      {
        ...toastOptions,
      }
    );
  },
};
export default customToast;
